<template>
  <div id="baptism-print-area" :style="pageStyle">

    <div v-if="institution !== null && member !== null" style="position: relative;">

      <!-- Background -->
      <img :src="bgImg" alt="Background Image"
           style="width: 297mm; height: 210mm; background-repeat: no-repeat;" />

      <!-- Name -->
      <div style="position:absolute; top:87mm; width:297mm; text-align:center;
                  font-size:150%; font-weight:bolder;">
        {{ member.gender === "MALE" ? "Mr." : "Ms." }}
        {{ ((member?.firstName || '') + ' ' + (member?.lastName || '')).toUpperCase() }}

      </div>

      <!-- Church Name -->
      <div style="position:absolute; top:124mm; width:297mm; text-align:center;
                  font-size:150%; font-weight:bolder;">
       <strong>{{ (institution?.name || '').toUpperCase() }}</strong>

      </div>

      <!-- Priest Signature -->
      <div style="position:absolute; top:140mm; left:35mm; width:45mm; height:15mm;">
        <img :src="priestSignatureImage"
             style="width:100%; height:auto; max-height:100%;" />
      </div>

      <!-- CERTIFICATE GENERATED DATE (ONLY THIS DATE SHOULD SHOW) -->
      <div style="position:absolute;
                  top:148mm;          /* vertical alignment */
                  left:225mm;         /* EXACT right alignment */
                  width:40mm;
                  text-align:center;
                  font-size:120%;
                  font-weight:bolder;">
        {{ formattedGeneratedDate }}
      </div>

      <!-- Certificate Number -->
      <div style="position:absolute; top:191.7mm; left:135mm; width:116mm;
                  color:#000; font-size:125%; font-weight:bolder;">
        {{ certificateNo }}
      </div>

    </div>

  </div>
</template>

<script>
import BaptismImg from "@/assets/img/Baptism-Sample.png";
import { SUPER_ADMINISTRATORS_ROLES } from "@/dashboard/members/members";
import { getDateFromTimeStamp } from "@/utils/AppFx";

export default {
  name: "PrintBaptismCertificate",

  props: {
    person: Object,
    showCertificate: Boolean,
    priestImage: Object,
    generatedDate: [String, Number]
  },

  computed: {
    member() {
      return this.person;
    },

    bgImg() {
      let store = this.$store.getters.getCertificatesBgs;
      return store?.BAPTISM ?? BaptismImg;
    },

    priestSignatureImage() {
      return this.$store.getters.getSignature;
    },

    certificateNo() {
      return this.member?.certificateNo ?? "MC/BPTM/0000000/1";
    },

  institution() {
    const user = this.$store.getters.getLoggedInUser;

    if (!user) {
        return this.$store.getters.getInstitution || {};
    }

    if (!user.userType) {
        return this.$store.getters.getInstitution || user.institution || {};
    }

    return SUPER_ADMINISTRATORS_ROLES.includes(user.userType)
        ? this.$store.getters.getInstitution
        : user.institution;
},


    formattedGeneratedDate() {
      if (!this.generatedDate) return "---";
      return getDateFromTimeStamp(this.generatedDate);
    }
  },

  methods: {
    getDateFromTimeStamp
  },

  data() {
    return {
      pageStyle: {
        height: "210mm",
        width: "297mm",
        overflow: "hidden"
      }
    };
  }
};
</script>

<style scoped></style>
